import React from 'react';
import PageHeader from '../../tenant_portal/shared/PageHeader';
import { useLoaderData, useLocation, useParams } from 'react-router-dom';
import { graphql } from 'relay-runtime';
import { PreloadedQuery, usePreloadedQuery, useQueryLoader } from 'react-relay';
import type {
  LinkAccountQuery as LinkAccountQueryType,
  LinkAccountQuery$data as LinkAccountQueryResponse,
} from './__generated__/LinkAccountQuery.graphql';
import Button from '../Button';
import {
  formatProviderName,
  getProviderLogoPath,
} from '../../components/Tools';
import loginStyles from '../../../../stylesheets/components/login.module.scss';

export const LinkAccountQuery = graphql`
  query LinkAccountQuery($token: String!) {
    oauthLinkActivation(token: $token) {
      email
      oauthProvider {
        email
        provider
      }
    }
  }
`;

const LinkAccount = () => {
  const { oauthLinkActivationToken } = useParams();
  const location = useLocation();

  const loaderQueryReference = useLoaderData() as PreloadedQuery<
    LinkAccountQueryType,
    LinkAccountQueryResponse
  >;

  const [queryReference] = useQueryLoader<LinkAccountQueryType>(
    LinkAccountQuery,
    loaderQueryReference
  );

  const loginActivationData = usePreloadedQuery<LinkAccountQueryType>(
    LinkAccountQuery,
    queryReference as PreloadedQuery<
      LinkAccountQueryType,
      LinkAccountQueryResponse
    >
  );

  const data = loginActivationData.oauthLinkActivation;

  const provider = data?.oauthProvider.provider;

  if (!data || !oauthLinkActivationToken || !provider) {
    return <div>There was an error.</div>;
  }
  const formattedProviderName = formatProviderName(provider);

  const handleLogin = (
    provider: string,
    oauth_link_activation_token: string
  ) => {
    const params = new URLSearchParams({
      provider,
      oauth_link_activation_token,
    });
    const entryPoint = new URLSearchParams(location.search).get('entry_point');
    if (entryPoint) {
      params.set('entry_point', entryPoint);
    }
    window.location.href = `${RAILS_BASE_URL}/session_transfers/oauth_redirect?${params.toString()}`;
  };

  return (
    <div className={loginStyles.loginRouteContent}>
      <PageHeader title="Link accounts" includeBottomMargin={false} />
      <Button
        onClick={() => handleLogin(provider, oauthLinkActivationToken)}
        logoPath={getProviderLogoPath(provider)}
        className={loginStyles.loginSocialButton}
        logoClassName={loginStyles.loginButtonLogo}
      >
        Continue with {formattedProviderName}
      </Button>
    </div>
  );
};

export default LinkAccount;
